module.exports = __webpack_public_path__ + "img/branding_upgrade_before.3853d2e.png";